import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useCompanyInfoFormStore } from 'store/pages/enrollment/company-info/companyInfoFormPageStore';
import ProposalStatusLayout from 'components/common/proposal/ProposalStatusLayout';
import { CARD_DATA } from 'global/checklists-helpers/ChecklistHelper';
import GeneratedContentFallback from 'components/common/general/GeneratedContentFallback';
import EnrollmentSafeguardPageHeader from 'components/common/enrollment/SafeguardPageHeader';
import { DynamicForm } from '@insurancemenu/imenu-components-lib';
import { SpinnerPlaceholder } from 'components/common/SpinnerPlaceholder';
import { PageWrapperStyled } from '../../../globalStyles';

// TESTING_POLICY: CYPRESS_ONLY

const Form: React.FC = observer(() => {
  const { dynamicFormDelegate, isInitialDataLoading, safeguardDelegate, enrollmentPeriodModule, getInitialData } =
    useCompanyInfoFormStore();

  useEffect(() => {
    void getInitialData();
  }, []);

  return (
    <>
      {isInitialDataLoading || !dynamicFormDelegate ? (
        <SpinnerPlaceholder height="40rem" />
      ) : (
        <DynamicForm
          formDelegate={dynamicFormDelegate}
          isEditable={!enrollmentPeriodModule.isEnrollmentImmutable}
          onBack={safeguardDelegate.onBackButtonStrategy}
          backButtonText={safeguardDelegate.isStepCompleted ? 'Exit' : 'Save & Exit'}
          completeButtonText={safeguardDelegate.isStepCompleted ? 'Update Company Info' : 'Complete Company Info'}
        />
      )}
    </>
  );
});

const PageContent: React.FC = observer(() => {
  const { generationFailed, safeguardDelegate, onBackRedirect } = useCompanyInfoFormStore();

  return (
    <ProposalStatusLayout>
      <GeneratedContentFallback isError={generationFailed} contentName="company info form" onGoBack={onBackRedirect}>
        <PageWrapperStyled>
          <EnrollmentSafeguardPageHeader
            title={CARD_DATA.COMPANY_INFO.title}
            subtitle={CARD_DATA.COMPANY_INFO.text}
            enrollmentHeaderSafeguardDelegate={safeguardDelegate}
          />
          <Form />
        </PageWrapperStyled>
      </GeneratedContentFallback>
    </ProposalStatusLayout>
  );
});

export default PageContent;
